import React from 'react';

import { PageTitle } from 'components/pages/pageTitle';
import { QaQueueListContainer } from './list/QaQueueListContainer';

export const QaQueue = () => {
  return (
    <>
      <PageTitle displayTitle="Virtual Graduation QA Queue" />
      <QaQueueListContainer />
    </>
  );
};
